import React from 'react';
import Link from 'next/link';

import SectionTitle from 'react-scale/components/elements/section-title';
import Section from 'react-scale/components/elements/section';

const About = ({ aboutSection }) => (
  <Section id="about" container={false}>
    <div className="container">
      <SectionTitle overtitle={aboutSection.overtitle} title={aboutSection.title} theme="light" />
      <div className="grid gap-12 text-base text-neutral-800 md:grid-cols-2">
        <div>
          <p className="mb-6 text-2xl leading-relaxed text-black">
            We believe that the transition from traditional software to AI is one of the most
            important shifts of our time. Our mission is to make that happen faster, across every
            industry.
          </p>
          <p className="mb-6">
            One of the biggest bottlenecks for real world AI applications is access to labeled data.
            Our first product is the most developer-friendly data labeling API for AI applications:{' '}
            <span> </span>
            <Link href="/self-driving-cars" className="text-link">
              self-driving cars,
            </Link>{' '}
            mapping,{' '}
            <Link href="/ar-vr" className="text-link">
              AR/VR,
            </Link>{' '}
            <Link href="/robotics" className="text-link">
              robotics,
            </Link>{' '}
            <Link href="/defense" className="text-link">
              government,
            </Link>{' '}
            <Link href="/retail" className="text-link">
              retail,
            </Link>{' '}
            and more.
          </p>
          <p>
            Our products for image annotation, semantic segmentation, 3D point cloud annotation, and
            LIDAR and RADAR annotation are used by industry leaders and provide world-class
            accuracy.
          </p>
        </div>
        <div>
          <h3 className="mb-6 text-2xl text-scale-periwinkle">Check out what makes us unique:</h3>
          <ul>
            <li className="flex flex-row mb-6">
              <img
                className="w-4 h-4 mt-1 mr-4"
                src="/static/img/website/careers/bullet.svg"
                alt="a bullet point"
              />
              <span>
                Our team is transforming how machine learning teams build innovative products.
              </span>
            </li>
            <li className="flex flex-row mb-6">
              <img
                className="w-4 h-4 mt-1 mr-4"
                src="/static/img/website/careers/bullet.svg"
                alt="a bullet point"
              />
              <span>
                We&apos;re a collaborative team that&apos;s always taking on complex challenges and
                finding new ways to solve problems.
              </span>
            </li>
            <li className="flex flex-row mb-6">
              <img
                className="w-4 h-4 mt-1 mr-4"
                src="/static/img/website/careers/bullet.svg"
                alt="a bullet point"
              />
              <span>
                We believe in empowering each individual while fostering collaboration to achieve
                success, and together, we are accelerating the development of AI applications.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </Section>
);

export default About;
